export default {
  overview: {
    title: "资产总览",
    todayIncome: "今日营业额",
    yesterdayIncome: "昨天营业额",
    platformIncome: "平台预计收入",
    riderIncome: "骑手预计收入",
    shopRecharge: "商户储值",
    shopRechargeAmount: "商户储值金额",
    rewardAmount: "奖惩金额",
    incomeBoard: "收入看板",
    dailyStats: "资金每日统计",
    yesterdayFullDay: "昨日全天",
    platformIncomeTip: "统计周期内，总收入减去骑手佣金支出后的金额",
    riderIncomeTip: "统计周期内，所有骑手接单后的预计收入",
    shopRechargeTip: "统计周期内，所有商户储值金额总和",
    rewardTip: "统计周期内，所有骑手奖惩金额总和",
    dateCol: "日期",
    orderCountCol: "订单数",
    revenueCol: "营业额",
    platformIncomeCol: "平台预计收入",
    riderCommissionCol: "骑手预计佣金",
    otherCol: "其他",
    chartTime: "时间：",
    totalStack: "总量",
  },
  riderAsset: {
    title: "骑士资产",
    pendingWithdraw: "待提现",
    withdrawn: "已提现",
    frozen: "冻结金额",
    withdrawApply: "骑手提现申请",
    todayExpected: "今日预计收入",
    todayExpectedTip: "统计周期内，骑手所接有效订单金额",
    pendingWithdrawTip: "统计周期内，骑手发起提现申请待审核金额",
    withdrawnTip: "统计周期内，骑手已提现金额",
    frozenTip: "统计周期内，骑手完成订单，未到达提现周期金额",
    riderNameCol: "骑手姓名",
    withdrawAmountCol: "提现金额",
    accountBalanceCol: "账户余额",
    withdrawMethodCol: "提现方式",
    orderCountChart: "订单数",
    riderExpectedChart: "骑手预计收入",
  },
  shopAsset: {
    title: "商户资产",
    recharge: "储值",
    consume: "消耗",
    gift: "赠送金额",
    rechargeBoard: "储值看板",
    todayRecharge: "今日储值金额",
    yesterdayRecharge: "昨天储值金额",
    remainingRecharge: "商户剩余储值",
    remainingTip: "统计周期内，商家现有储值总和",
    consumeRecharge: "商户消耗储值",
    consumeTip: "统计周期内，商户推单消费储值总和",
    giftRecharge: "赠送储值金额",
    giftTip: "商户储值时，平台额外赠送储值金额统计",
    totalRecharge: "商户储值总额",
    totalTip: "统计周期内，所有商户储值加赠送金额总和",
    shopStats: "商户储值统计",
    payAmountCol: "商户支付金额",
    rechargeAmountCol: "商户储值金额",
    orderCountCol: "订单数",
    shopPayChart: "商户支出金额",
    shopRechargeChart: "商户储值金额",
  },
  withdrawal: {
    listTitle: "提现列表",
    withdrawTime: "提现时间",
    riderName: "骑手姓名",
    withdrawMethod: "提现方式",
    withdrawAmount: "提现金额(元)",
    fee: "手续费(元)",
    actualAmount: "到账金额(元)",
    status: "状态",
    wechat: "微信",
    alipay: "支付宝",
    unionpay: "银联",
    applying: "申请中",
    approved: "已通过",
    rejected: "提现已拒绝",
    detail: "详细信息",
    rider: "骑手",
    payee: "收款码",
    bankCard: "银行卡号",
    reservePhone: "预留手机号",
    bankName: "开户行",
    bankBranch: "所属支行",
    actualMoneyLabel: "实际金额",
    pass: "通过",
    reject: "拒绝",
  },
  withdrawalSettings: {
    title: "提现设置",
    enableWithdraw: "开启提现",
    minAmount: "最低提现金额",
    feeRate: "费率",
    fee: "手续费",
    interval: "提现间隔周期",
  },
};
